import { useState } from "react";
import { Link } from "react-router-dom";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, extractError } from "@/lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (e) {
      setErr(extractError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grain min-h-screen flex items-center justify-center px-6 py-12 relative">
      <div className="w-full max-w-md relative z-10">
        <Link to="/" className="flex items-center gap-3 mb-10 justify-center">
          <div className="w-10 h-10 rounded-full bg-rose-600 flex items-center justify-center text-lg">🐼</div>
          <span className="font-display text-2xl tracking-tight">My Panda X</span>
        </Link>
        <div className="card-surface p-8">
          <h1 className="font-display text-3xl mb-1">Forgot password.</h1>
          <p className="text-sm text-zinc-400 mb-8">
            We'll send you a reset link if this email exists in our vault.
          </p>

          {sent ? (
            <div className="border-l-2 border-rose-500 pl-4 py-2 text-sm text-zinc-300 leading-relaxed">
              If an account exists for <span className="text-white">{email}</span>, a reset link has
              been sent. Check your inbox (and spam folder) — the link expires in 1 hour.
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-5">
              <div>
                <Label className="text-xs uppercase tracking-widest text-zinc-500">Email</Label>
                <Input
                  data-testid="forgot-email-input"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-2 bg-black/40 border-white/10 rounded-none py-6 focus-visible:ring-rose-600"
                />
              </div>
              {err && (
                <div className="text-sm text-rose-500 border-l-2 border-rose-500 pl-3">{err}</div>
              )}
              <Button
                data-testid="forgot-submit-button"
                type="submit"
                disabled={busy}
                className="btn-crimson w-full rounded-none py-6 tracking-wide"
              >
                {busy ? "Sending…" : "Send reset link"}
              </Button>
            </form>
          )}

          <div className="mt-8 text-sm text-zinc-400 text-center">
            <Link to="/login" className="text-rose-500 hover:underline">
              Back to login
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
